export const IMAGES = 'images';
export const VIDEOS = 'videos';
